import ListPageLayout from './ListPageLayout.vue';

export default ListPageLayout;



// WEBPACK FOOTER //
// ./src/uikit/layouts/listlayouts/ListPageLayout/index.ts